<template>
<div class="page-effect">
<header class="header-navbar sticky-top">
<div class="container-fluid">
<div class="row">
<div class="col-md-12 p-0">
<div class="d-md-flex align-items-center justify-content-between">
<div class="left-logo" style="width: 100%">
<img v-if="BannerURL" id="imgBanner" v-bind:src="BannerURL" />
</div>
</div>
</div>
</div>
</div>
</header>
<!---->
<section class="ss-reg-top">
<div class="container-fluid border-bottom">
<div class="d-md-flex justify-content-end">
<a href="#" class="wet" data-toggle="modal" data-target="#welcomemailModalCenter">Welcome Mail Template</a>
<a href="#" class="regt" data-toggle="modal" data-target="#RegistrationtypeModal">Registration Type</a>
<a href="#" class="chf" data-toggle="modal" data-target="#CheckoutformypeModal">Checkout Form</a>
</div>
</div>
</section>
<!---->
<section
class="register-page-wrapper body-content event-reg-speakers"
style="background-color: #ffffff"
>
<div class="container reg-v2reg px-mob-0">
<div class="col-lg-10 mx-auto">
<div class="row">
<div class="col-lg-12 mob-py-0">
<div class="top-right-login text-right hdr-btn mb-md-3 login-ico">
<!-- <a class="event-List">Event List</a> -->
&nbsp;
<a
v-show="Config.LandingPageShowEventListLink"
v-on:click="goForEventList"
class="event-List mob-my-0"
>Event List</a
>
<a v-on:click="goForLogin" class="login mob-my-0">Login</a>
</div>
<div class="event_banner">
<!-- <img src="images/event-banner.jpg" alt="e2m" /> -->
<!-- <img id="imgBanner" v-bind:src="BannerURL" alt="e2m" /> -->
<v-img
id="imgBannerEvnt"
:src="EventsData.length > 0 ? EventsData[0].EventLogo : ''"
/>
</div>
<div class="row my-4">
<div class="col-lg-8 col-md-6">
<h1 class="page-head mb-2" v-if="EventsData[0]">
{{ EventsData[0].EventName }}
</h1>
&nbsp;
<div class="top-right-login">
<a
href="javascript:void(0);"
style="pointer-events: none"
class="event-List"
v-if="EventsData[0]"
>{{ EventsData[0].EventStartDateZ }}&nbsp; to &nbsp;{{
EventsData[0].EventEndDateZ
}}
&nbsp;{{ EventsData[0].EventTimezoneZ }}</a
>
</div>
</div>
<!-- v-on:click="goForRegister" -->
<div class="col-lg-4 col-md-6 text-md-right reg-v2-r-w">
<p class="text-left mb-1">
<span class="text-m">
{{
getMaxMinPrice.minPrice
? `From ${getcurrency}${getMaxMinPrice.minPrice}`
: "FREE"
}}
</span>
<span class="text-m">
{{
getMaxMinPrice.maxPrice
? `To ${getcurrency}${getMaxMinPrice.maxPrice}`
: ""
}}
</span>
</p>
<!-- <button
v-if="
RegistrationTypes.length == 1 &&
RegistrationTypes[0].MaxLimit == 1
"
id="btnRegister"
type="submit"
class="btn reg-button text-uppercase"
style="
background: #288af2 !important;
color: #fff !important;
"
@click.prevent="directFormOpen"
>
Register for the event
</button> -->
<v-btn
v-if="
RegistrationTypes.length == 1 &&
RegistrationTypes[0].MaxLimit == 1
"
id="btnRegister"
class="btn reg-button text-uppercase"
style="
background: #288af2 !important;
color: #fff !important;
font-size: 16px;
padding: 10px 25px;
height: 44px;
letter-spacing: unset;
"
@click.prevent="directFormOpen"
:loading="IsSubmitting"
>
{{ RegisterButtonText }}
</v-btn>
<!-- data-target="#register_popup" -->
<button
v-else
id="btnRegister"
type="submit"
class="btn reg-button text-uppercase"
data-toggle="modal"
style="
background: #288af2 !important;
color: #fff !important;
"
@click="OpenCheckoutForm"
>
{{ RegisterButtonText }}
</button>
</div>
</div>
</div>
<!---hosted by-->
<div
v-show="Config.LandingPageShowHostedByPanel"
class="col-md-12 pt-0"
>
<div
class="
media
border
p-4
full-width
hosted-box
align-items-center
"
>
<!-- <img
src="images/reg-banner.jpg"
alt="John Doe"
class="mr-3 rounded-circle"
style="width:60px;height: 60px;"
/>-->
<span
class="
imageCircle
height-removed
reg-prof-img
new-reg
p-2
rounded
"
>
<img id="imgBanner" v-bind:src="clientLogoUrl" />
</span>
<div class="media-body pl-2 border-r-none">
<h6>Hosted By</h6>
<h5>{{ clientName }}</h5>
</div>
<p v-html="clientProfile" class="m-0 border-left pr-2 pl-3"></p>
</div>
</div>
<!---------->
</div>
<!------tab area start-------->
<section
class="session-list-wrapper p-0 mt-3 SessionlistMultitracker"
>
<div class="reg-page-tab-hld">
<ul class="nav nav-tabs mb-4 pl-0" role="tablist">
<li class="nav-item">
<a
class="nav-link active acnhDescription"
data-toggle="tab"
href="#description"
>description</a
>
</li>
<li class="nav-item">
<a class="nav-link acnhDescription" data-toggle="tab" href="#Sessions">Sessions</a>
<label class="switch">
<input type="checkbox" checked>
<span class="slider round"></span>
</label>
</li>
<li class="nav-item">
<a class="nav-link acnhDescription" data-toggle="tab" href="#SpeakersHost">Speakers & Host</a>
<label class="switch">
<input type="checkbox" checked>
<span class="slider round"></span>
</label>
</li>
</ul>
<!------tab content start------>
<div class="tab-content ss-t-content">
<div
id="description"
v-if="EventsData[0]"
v-html="EventsData[0].Description"
class="tab-pane active"
></div>
<div id="Sessions" class="tab-pane fade">
<div class="d-flex align-items-center justify-content-between">
<h4>Sessions </h4>
<!--Create New button-->
<div class="dropdown ss-create-new">
<button type="button" class="btn btn-primary reg-button dropdown-toggle" data-toggle="dropdown">
Create New 
</button>
<div class="dropdown-menu">
<a class="dropdown-item ss-lpico" href="#" data-toggle="modal" data-target="#crcrenew-session-popuop">Live Panel (Webiner)</a>
<a class="dropdown-item ss-rtico" href="#">Round Table</a>
<a class="dropdown-item ss-ltico" href="#">Live Stream </a>
<a class="dropdown-item ss-ondico" href="#">On Demand </a>
<a class="dropdown-item ss-inpico" href="#">In-Person </a>
</div>
</div>
<!--Create New button end-->
</div>
<!-------session box---->
<!-------single session box start---->
<div class="white-box-wrapper one-session">
<div class="time-location no-track">
<ul>
<li><span> 12:00 AM <br/> 11:59 PM </span></li>
</ul>
</div>
<div  class="main-divider-wrap my-0 py-0">
<div class="row main-divider my-0 py-0 mr-2">
<div class="col-lg-8 col-md-6 py-0">
<div class="col-12 pl-0 py-0">
<div class="session-status">
<p><span class="active-session"></span> Live </p>
</div>
</div>
<div data-toggle="modal"  data-tag="singleSessionDetails" class="left-area-hld">
<h2 data-toggle="tooltip" data-placement="top" data-original-title="Live Panel1"> Live Panel1 </h2>
<p class="m-0"> Short Description </p>
</div>
<!---->
</div>
<div class="col-lg-4 col-md-6 pl-0">
<div class="right-area-hld">
<div id="dvBroadcast" class="dvBroadcast161353">
<div class="d-flex align-items-center">
<a data-toggle="modal"  data-tag="sessionSpeakerDetails" class="schedule-speaker w-inline-block">
<img src="https://resources.e2m.live/uate2monair.appspot.com/OA_UAT_C1591205467009E1591206650065%2FAttendees%2F221000_1611595430862_Debashis.PNG?alt=media&amp;token=1d615069-997a-45f6-8d30-6c3cb9943c27" alt="DG" data-toggle="tooltip" data-html="true" title="" class="schedule-speaker-image"></a>
<a data-toggle="modal" data-target="#speaker42001" data-tag="sessionSpeakerDetails" class="schedule-speaker w-inline-block"><img src="https://resources.e2m.live/uate2monair.appspot.com/OA_UAT_C1591205467009E1591206650065%2FAttendees%2F42001_1617620791557_42001_1596168201183_1031998_th1.jpg?alt=media&amp;token=51ca588e-169d-46ce-87d0-b15c8998861e" alt="DM" data-toggle="tooltip" data-html="true" title="" class="schedule-speaker-image"></a>
<a data-toggle="modal" data-target="#speaker51023" data-tag="sessionSpeakerDetails" class="schedule-speaker w-inline-block"><span data-toggle="tooltip" data-html="true" title=""  class="speaker-name-initial">+12</span></a>


<a href="javascript:void(0)"  data-toggle="tooltip" data-placement="top" title="" data-original-title="Live Panel" data-tag="forGreenRoom" class="icon-bookmark1 bmark-pupupbtn new-btn-design ongoing-status">
<img src="../assets/Images/live-panel-white.svg" alt="onair"/><span>JOIN NOW</span></a>
</div>
</div>
</div>
</div>
</div>
</div>
</div>

<!-------session box end---->
<!-------single session box start---->
<div class="white-box-wrapper one-session">
<div class="time-location no-track">
<ul>
<li><span> 12:00 AM <br/> 11:59 PM </span></li>
</ul>
</div>
<div  class="main-divider-wrap my-0 py-0">
<div class="row main-divider my-0 py-0 mr-2">
<div class="col-lg-8 col-md-6 py-0">
<div class="col-12 pl-0 py-0">
<div class="session-status">
<p><span class="active-session"></span> Live </p>
</div>
</div>
<div data-toggle="modal"  data-tag="singleSessionDetails" class="left-area-hld">
<h2 data-toggle="tooltip" data-placement="top" data-original-title="Live Panel1"> Live Panel1 </h2>
<p class="m-0"> Short Description </p>
</div>
<!---->
</div>
<div class="col-lg-4 col-md-6 pl-0">
<div class="right-area-hld">
<div id="dvBroadcast" class="dvBroadcast161353">
<div class="d-flex align-items-center">
<a data-toggle="modal"  data-tag="sessionSpeakerDetails" class="schedule-speaker w-inline-block">
<img src="https://resources.e2m.live/uate2monair.appspot.com/OA_UAT_C1591205467009E1591206650065%2FAttendees%2F221000_1611595430862_Debashis.PNG?alt=media&amp;token=1d615069-997a-45f6-8d30-6c3cb9943c27" alt="DG" data-toggle="tooltip" data-html="true" title="" class="schedule-speaker-image"></a>
<a data-toggle="modal" data-target="#speaker42001" data-tag="sessionSpeakerDetails" class="schedule-speaker w-inline-block"><img src="https://resources.e2m.live/uate2monair.appspot.com/OA_UAT_C1591205467009E1591206650065%2FAttendees%2F42001_1617620791557_42001_1596168201183_1031998_th1.jpg?alt=media&amp;token=51ca588e-169d-46ce-87d0-b15c8998861e" alt="DM" data-toggle="tooltip" data-html="true" title="" class="schedule-speaker-image"></a>
<a data-toggle="modal" data-target="#speaker51023" data-tag="sessionSpeakerDetails" class="schedule-speaker w-inline-block"><span data-toggle="tooltip" data-html="true" title=""  class="speaker-name-initial">+12</span></a>


<a href="javascript:void(0)"  data-toggle="tooltip" data-placement="top" title="" data-original-title="Live Panel" data-tag="forGreenRoom" class="icon-bookmark1 bmark-pupupbtn new-btn-design ongoing-status">
<img src="../assets/Images/live-panel-white.svg" alt="onair"/><span>JOIN NOW</span></a>
</div>
</div>
</div>
</div>
</div>
</div>
</div>

<!-------session box end---->
</div>
<!--session tab end-->
<div id="SpeakersHost" class="tab-pane fade">
<h4>9 Speakers & Host</h4>
<div class="row">
<!-----Add speakers list start------->
<div class="col-md-3">
<div class="media ss-add-new" data-toggle="modal" data-target="#add-speaker">
<div class="i-holder">
<img
src="../assets/Images/icons/add-new.svg"
alt="Generic placeholder image"
/>
</div>
<div class="media-body pl-2">
<h5 class="mt-0">Add Speaker</h5>
</div>
</div>
</div>
<!-----Add speakers list box end------->
<!-----speakers list start------->
<div class="col-md-3">
<div class="media">
<div class="i-holder">
<img
src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSpeaker%2F1.%20Dr%20Ivan%20Misner.jpg?alt=media"
alt="Generic placeholder image"
/>
</div>
<div class="media-body pl-2">
<h5 class="mt-0">Media heading</h5>
<p class="po-ad">BNI | District Director</p>


</div>
</div>
</div>
<!-----speakers list box end------->
<!-----speakers list start------->
<div class="col-md-3">
<div class="media">
<div class="i-holder">
<img
src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSpeaker%2F1.%20Dr%20Ivan%20Misner.jpg?alt=media"
alt="Generic placeholder image"
/>
</div>
<div class="media-body pl-2">
<h5 class="mt-0">Media heading</h5>
<p class="po-ad">BNI | District Director</p>


</div>
</div>
</div>
<!-----speakers list box end------->
<!-----speakers list start------->
<div class="col-md-3">
<div class="media">
<div class="i-holder">
<img
src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSpeaker%2F1.%20Dr%20Ivan%20Misner.jpg?alt=media"
alt="Generic placeholder image"
/>
</div>
<div class="media-body pl-2">
<h5 class="mt-0">Media heading</h5>
<p class="po-ad">BNI | District Director</p>

</div>
</div>
</div>
<!-----speakers list box end------->
<!-----speakers list start------->
<div class="col-md-3">
<div class="media">
<div class="i-holder">
<img
src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSpeaker%2F1.%20Dr%20Ivan%20Misner.jpg?alt=media"
alt="Generic placeholder image"
/>
</div>
<div class="media-body pl-2">
<h5 class="mt-0">Media heading</h5>
<p class="po-ad">BNI | District Director</p>

</div>
</div>
</div>
<!-----speakers list box end------->
</div>
</div>
</div>
<!------tab content end------>
</div>
</section>
<!------tab area end-------->
</div>
</div>
</section>
<!---register popup-->
<div
class="modal fade register_popup"
id="register_popup"
tabindex="-1"
role="dialog"
aria-labelledby="exampleModalCenterTitle"
aria-hidden="true"
>
<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
<div class="modal-content">
<div
class="
modal-header
justify-content-center
flex-column
align-items-center
"
>
<h5 class="modal-title" id="exampleModalLongTitle">
{{ EventsData[0].EventName }}
</h5>
<p>
{{ EventsData[0].EventStartDateZ }} -
{{ EventsData[0].EventEndDateZ }}
{{ EventsData[0].EventTimezoneZ }}
</p>
<!-- data-dismiss="modal" -->
<button
type="button"
class="close"
ref="close_modal"
aria-label="Close"
@click="CloseCheckoutForm"
>
<span aria-hidden="true">&times;</span>
</button>
</div>
<div class="modal-body">
<div class="row reg-row mt-0">
<div class="col-lg-7 col-md-7 reg-left-side">
<!---box start-->
<div
class="d-flex justify-content-between align-items-center"
v-for="(item, index) in RegistrationTypes"
:key="index"
>
<div class="reg_box_inner_l">
<h2>{{ item.RegistrationType }}</h2>
<p v-if="item.FormType == 'Paid'">
<span class="text-m"
>{{ item.Currency.symbol }} {{ item.Price }}</span
>
{{
item.PriceIncludingTax == false
? `+ Taxes ${item.Tax}%`
: ""
}}
</p>
<p v-else><span class="text-m">Free</span></p>
<p>
Sale form {{ item.SaleStartDate | momentConvert }} to
{{ item.SaleEndDate | momentConvert }}
</p>
</div>
<div
class="reg_box_inner_r red--text"
v-if="item.isInActiveTicket"
>
{{ item.InActiveMessage }}
</div>
<div class="reg_box_inner_r" v-else>
<div class="form-group mb-0">
<select
class="form-control"
v-model="item.selectedQuantity"
>
<option :value="0" :key="0" selected="selected">
0
</option>
<option
v-for="oindex in Number(item.MaxLimit)"
:key="oindex"
:value="oindex"
>
{{ oindex }}
</option>
</select>
</div>
</div>
</div>
<!---box end-->
</div>
<div class="col-lg-5 col-md-5 reg-right-side">
<div class="reg-r-inner-w border">
<v-img
id="imgBannerEvnt"
:src="EventsData.length > 0 ? EventsData[0].EventLogo : ''"
/>
<h4 class="my-4">Use Coupon Code</h4>
<div class="form-group position-relative reg-cc mb-0">
<input type="Text" placeholder="Enter Coupon Code" class="form-control">
<button class="btn btn-default">APPLY</button>
</div>
<hr/>
<h4>Order Summary</h4>
<!-- <p class="d-flex justify-content-between  mb-2"><span>1 x Generel Admission</span> <span>US$ 0.00</span></p> -->
<table class="full-width">
<tr v-for="(item, index) in RegistrationTypes" :key="index">
<td v-if="Number(item.selectedQuantity)">
{{ item.selectedQuantity }} x
{{ item.RegistrationType }}
</td>
<td
v-if="
item.FormType == 'Paid' &&
Number(item.selectedQuantity)
"
>
{{ item.Currency.symbol }}
{{
(
Number(item.selectedQuantity) * Number(item.Price)
).toFixed(2)
}}
</td>
<td
v-if="
item.FormType == 'Free' &&
Number(item.selectedQuantity)
"
>
Free
</td>
</tr>
<tr>
<td>Sub Total</td>
<td>
{{ getcurrency }} {{ Number(getsubtotal).toFixed(2) }}
</td>
</tr>
<tr v-if="getsubtotal">
<td>Taxes</td>
<td>
{{ getcurrency }} {{ Number(taxPrice).toFixed(2) }}
</td>
</tr>
<tr>
<td colspan="2" class="position-relative">
<div class="circle circle-cu-left"></div>
<div class="circle circle-cu-right"></div>
<hr />
</td>
</tr>
<tr>
<td>
<h2>Total</h2>
</td>
<td>
<h2>
{{ getcurrency }}
{{
(Number(getsubtotal) + Number(taxPrice)).toFixed(2)
}}
</h2>
</td>
</tr>
</table>
<div class="register-page-wrapper">
<!--mobile only-->
<div
class="
d-md-none
align-items-center
justify-content-between
"
>
<h5 class="text-left pr-2">
Total
<span class="text-m d-block pt-1"
>{{ getcurrency }}
{{
(Number(getsubtotal) + Number(taxPrice)).toFixed(2)
}}</span
>
</h5>
</div>
<v-btn
:loading="IsSubmitting"
class="btn reg-button reg-button"
style="color: #fff; font-size: 16px"
@click="goForRegister"
>
{{ CheckoutButtonText }}
</v-btn>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
<!----create new-session-popuop start------>
<!-- The Modal -->
<div class="modal fade crenew-session-popuop" id="crcrenew-session-popuop">
<div class="modal-dialog modal-lg">
<div class="modal-content">
<!-- Modal Header -->
<div class="register_popup">
<div class="modal-header">
<h4 class="modal-title page-head">Create New Session</h4>
<button type="button" class="close" data-dismiss="modal">&times;</button>
</div>
</div>

<!-- Modal body -->
<div class="modal-body">
<div class="ss-cns-body-wrap">
<div class="d-flex align-items-center l-text ss-str-clnt mb-5">
Streaming Client:
<input type="radio" id="streamingClient" name="radio-group" checked>
<label for="streamingClient">Zoom</label>
<span class="ss-info" data-toggle="tooltip" title="info Text">
<img src="../assets/Images/reg-ico/info.svg" alt="onair"/>
</span>
<input type="radio" id="streamingClient-2" name="radio-group" />
<label for="streamingClient-2">Web</label>
<span class="ss-info" data-toggle="tooltip" title="info Text">
<img src="../assets/Images/reg-ico/info.svg" alt="onair"/>
</span>

</div>
<div class="form-group">
<label>Session Title*</label>
<input type="Text" class="form-control ss-cns-name" placeholder="Enter Session Title" >
</div>
<div class="form-group mb-0">
<label>Description (Optional)</label>
<textarea type="Text" class="form-control" placeholder="" cols="4" rows="3">
</textarea>
</div>
<hr/>
<div class="row">
<div class="col-md-4 pr-1">
<div class="form-group">
<label>Start on*</label>
<input type="datetime-local" class="form-control" placeholder="Enter Session Title" >

</div>
</div>
<div class="col-md-4 pl-1">
<div class="form-group">
<label>Ends on*</label>
<input type="datetime-local" class="form-control" placeholder="Enter Session Title" >				
</div>
</div>
</div>
<div class="row">
<div class="col-md-6">
<div class="form-group">
<label>Select a Speaker*</label>
<select type="" class="form-control" >
<option>Select</option>
<option>A</option>
<option>b</option>
</select>	
</div>
</div>
<div class="col-md-6">
<div class="form-group">
<label>Select a Host*</label>
<select type="" class="form-control" >
<option>Select</option>
<option>A</option>
<option>b</option>
</select>	
</div>
</div>
<div class="col-md-6">
<div class="form-group">
<label>Session Visible for*</label>
<select type="" class="form-control" >
<option>List of attendees</option>
<option>A</option>
<option>b</option>
</select>
</div>

</div>
<div class="col-md-6">

<div class="form-group">
<label>Select Attendees*</label>
<select type="" class="form-control" >
<option>Floyd</option>
<option>Mario</option>
</select>
</div>
</div>
</div>
<div class=" reg-page-tab-hld mt-4">
<div class="d-flex align-items-center l-text reg-page-tab-hld ">
Enable RTMP Stream 
<label class="switch ml-3 mb-0"><input type="checkbox" checked="checked"><span class="slider round"></span>
</label>
<span class="ss-info" data-toggle="tooltip" title="info Text">
<img src="../assets/Images/reg-ico/info.svg" alt="onair"/>
</span>
</div>
</div>

</div>
</div>

<!-- Modal footer -->
<div class="modal-footer ss-cns-foo-btn">
<button type="button" class="btn btn-default">Back  to List</button>
<button type="button" class="btn btn-primary" >Save & Continue</button>
</div>

</div>
</div>
</div>
<!----create new-session-popuop end------>
<!----create new-session-popuop start------>
<!-- The Modal -->
<div class="modal fade crenew-session-popuop add-speaker" id="add-speaker">
<div class="modal-dialog modal-lg">
<div class="modal-content">
<!-- Modal Header -->
<div class="register_popup">
<div class="modal-header">
<h4 class="modal-title page-head">Add New Speaker</h4>
<button type="button" class="close" data-dismiss="modal">&times;</button>
</div>
</div>

<!-- Modal body -->
<div class="modal-body">
<div class="ss-cns-body-wrap">
<h5 class="my-4"><strong>Basic Info</strong></h5>
<!--top area start-->
<div class="row">
<div class="col-md-6">

<div class="form-group">
<label>Attendee Name*</label>
<input type="Text" class="form-control ss-cns-name" placeholder="Attendee Name" >
</div>
<div class="form-group">
<label>Email*</label>
<input type="Text" class="form-control" placeholder="Enter Email" >
</div>
<div class="form-group">
<label>Phone Number</label>
<input type="Text" class="form-control" placeholder="Enter Phone Number" >
</div>
<hr/>
</div>
<div class="col-md-6 ss-add-imgbox-wrap text-center">
<div class="ss-add-imgbox mx-auto">
<img src="../assets/Images/attendee.png" alt="e2m">

</div>
<p>JPG or PNG no larger than 3MB.<br/>Square image looks the best</p>
<div class="custom--inputfile-btn-hld">
<input type="file" class="custom--inputfile"> 
<button type="button" class="btn btn-default">Choose File</button>
</div>
</div>
</div>
<!--top area end-->

<h5 class="my-4"><strong>Others Info (Optional)</strong></h5>
<div class="row">
<div class="col-md-6">
<div class="form-group">
<label>Organization</label>
<input type="Text" class="form-control" placeholder="Organization Name" >
</div>
</div>
<div class="col-md-6">
<div class="form-group">
<label>Job Title</label>
<input type="Text" class="form-control" placeholder="Add Job Title" >
</div>
</div>
<div class="col-md-6">
<div class="form-group">
<label>Website</label>
<input type="Text" class="form-control" placeholder="Organization Name" >
</div>
</div>
<div class="col-md-6">
<div class="form-group">
<label>Country</label>
<select type="" class="form-control" >
<option>Select</option>
<option>A</option>
<option>b</option>
</select>	
</div>
</div>
<div class="col-md-12">
<div class="form-group mb-0">
<label>Enter Search Keywords</label>
<textarea type="Text" class="form-control" cols="5" placeholder="Add multiple Keywords separated by comma.eg:marketing,branding,techonology">

</textarea>
</div>
</div>
<div class="col-md-12 pt-0">
<label>Short Bio</label>
<textarea type="Text" class="form-control" placeholder="">

</textarea>
</div>

</div>


</div>
</div>

<!-- Modal footer -->
<div class="modal-footer ss-cns-foo-btn">
<button type="button" class="btn btn-default px-8" >Cancel</button>
<button type="button" class="btn btn-primary px-8" data-dismiss="modal" data-toggle="modal" data-target="#ss-success-modal">Save</button>
</div>

</div>
</div>
</div>
<!----create new-session-popuop end------>
<!-----Checkout form modal------->
<div class="modal right fade ss-checkout-form-modal" id="CheckoutformypeModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="checkout-head mb-4">
            <h3 class="mb-0 d-none">CHECKOUT FROMS</h3>
            <h3 class="mb-0"><span class="mr-3"><v-icon dark color="#333" size="25px">mdi-arrow-left</v-icon></span> ADD CHECKOUT FORMS</h3>
            <div  class="close-check" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </div>
        </div>
        <div class="create-form-class d-none final-button">
           <v-btn color="#1c1d26" dark large><span class="mr-2"><img src="../assets/Images/reg-ico/create-new-reg-type.svg"/></span> Create New</v-btn> 
        </div>
        <div class="checkout-form-list d-none">
            <table>
                <thead>
                    <tr>
                        <th>
                            <v-checkbox
                            v-model="ex4"
                            color="primary"
                            hide-details
                            ></v-checkbox>
                        </th>
                        <th>From Title <span><img src="../assets/Images/reg-ico/table-filter.svg"/></span></th>
                        <th>Type</th>
                        <th>Assign to</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <v-checkbox
                            v-model="ex4"
                            color="primary"
                            hide-details
                            ></v-checkbox>
                        </td>
                        <td>Free Form</td>
                        <td>Free</td>
                        <td>2 Tickets <span><v-icon dark color="#333" size="25px">mdi-information-outline</v-icon></span></td>
                        <td>
                            <ul>
                                <li><v-icon dark color="#333" size="25px">mdi-content-copy</v-icon></li>
                                <li><img src="../assets/Images/reg-ico/edit.svg"/></li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <v-checkbox
                            v-model="ex4"
                            color="primary"
                            hide-details
                            ></v-checkbox>
                        </td>
                        <td>Form for Attendees</td>
                        <td>Free</td>
                        <td>3 Tickets <span><v-icon dark color="#333" size="25px">mdi-information-outline</v-icon></span></td>
                        <td>
                            <ul>
                                <li><v-icon dark color="#333" size="25px">mdi-content-copy</v-icon></li>
                                <li><img src="../assets/Images/reg-ico/edit.svg"/></li>
                            </ul>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <v-checkbox
                            v-model="ex4"
                            color="primary"
                            hide-details
                            ></v-checkbox>
                        </td>
                        <td>Commissioner Form</td>
                        <td>Paid</td>
                        <td>1 Tickets <span><v-icon dark color="#333" size="25px">mdi-information-outline</v-icon></span></td>
                        <td>
                            <ul>
                                <li><v-icon dark color="#333" size="25px">mdi-content-copy</v-icon></li>
                                <li><img src="../assets/Images/reg-ico/edit.svg"/></li>
                            </ul>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <v-checkbox
                            v-model="ex4"
                            color="primary"
                            hide-details
                            ></v-checkbox>
                        </td>
                        <td>Staff</td>
                        <td>Paid</td>
                        <td>0 Tickets <span><v-icon dark color="#333" size="25px">mdi-information-outline</v-icon></span></td>
                        <td>
                            <ul>
                                <li><v-icon dark color="#333" size="25px">mdi-content-copy</v-icon></li>
                                <li><img src="../assets/Images/reg-ico/edit.svg"/></li>
                            </ul>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <v-checkbox
                            v-model="ex4"
                            color="primary"
                            hide-details
                            ></v-checkbox>
                        </td>
                        <td>Test Form 01</td>
                        <td>Free</td>
                        <td>0 Tickets <span><v-icon dark color="#333" size="25px">mdi-information-outline</v-icon></span></td>
                        <td>
                            <ul>
                                <li><v-icon dark color="#333" size="25px">mdi-content-copy</v-icon></li>
                                <li><img src="../assets/Images/reg-ico/edit.svg"/></li>
                            </ul>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <v-checkbox
                            v-model="ex4"
                            color="primary"
                            hide-details
                            ></v-checkbox>
                        </td>
                        <td>Test Form 02</td>
                        <td>Free</td>
                        <td>0 Tickets <span><v-icon dark color="#333" size="25px">mdi-information-outline</v-icon></span></td>
                        <td>
                            <ul>
                                <li><v-icon dark color="#333" size="25px">mdi-content-copy</v-icon></li>
                                <li><img src="../assets/Images/reg-ico/edit.svg"/></li>
                            </ul>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <v-checkbox
                            v-model="ex4"
                            color="primary"
                            hide-details
                            ></v-checkbox>
                        </td>
                        <td>Test Form 03</td>
                        <td>Free</td>
                        <td>0 Tickets <span><v-icon dark color="#333" size="25px">mdi-information-outline</v-icon></span></td>
                        <td>
                            <ul>
                                <li><v-icon dark color="#333" size="25px">mdi-content-copy</v-icon></li>
                                <li><img src="../assets/Images/reg-ico/edit.svg"/></li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="add-chek-out-form-wrap">
            <label>From Name*</label>
            <input type="text" name="" value="" id="" />

            <label>Assign to Registration Type <span><v-icon dark color="#333" size="25px">mdi-information-outline</v-icon></span></label>
            <v-select v-model="value" :items="items" chips label="Chips" multiple solo ></v-select>
            <hr/>
            <div class="self-questions mb-3">
                <h5 class="mb-5">Questions</h5>
                <div class="single-question mb-2">
                    <div class="question-left">
                        <v-icon dark color="#333" size="25px">mdi-drag-vertical</v-icon>
                        <v-icon dark color="#333" size="25px">mdi-menu</v-icon>
                        <p>First Name*</p>
                    </div>
                    <span><v-icon dark color="#333" size="25px">mdi-square-edit-outline</v-icon></span>
                </div>
                 <div class="single-question mb-2">
                    <div class="question-left">
                        <v-icon dark color="#333" size="25px">mdi-drag-vertical</v-icon>
                        <v-icon dark color="#333" size="25px">mdi-menu</v-icon>
                        <p>Last Name*</p>
                    </div>
                    <span><v-icon dark color="#333" size="25px">mdi-square-edit-outline</v-icon></span>
                </div>


                 <div class="single-question mb-2">
                    <div class="question-left">
                        <v-icon dark color="#333" size="25px">mdi-drag-vertical</v-icon>
                        <v-icon dark color="#333" size="25px">mdi-at</v-icon>
                        <p>Email</p>
                    </div>
                    <span><v-icon dark color="#333" size="25px">mdi-square-edit-outline</v-icon></span>
                </div>
                <v-btn class="mx-0" large depressed outlined color="#000000">Add Question</v-btn>

            </div>
            <div class="d-flex justify-content-end mt-12">
                <v-btn class="my-0 ml-0 mr-2" min-width="100" large depressed outlined color="#000000" data-dismiss="modal">Cancel</v-btn>
                <v-btn min-width="100" large  depressed color="primary">Save</v-btn>
            </div>
           
        </div>
      </div>
      
    </div>
  </div>
</div>



<!-----Checkout form modal------->
<!---success modal---->
<!-- Modal -->
<div id="ss-success-modal" class="modal fade ss-success-modal" role="dialog">
<div class="modal-dialog">

<!-- Modal content-->
<div class="modal-content">

<div class="modal-body">
<img src="../assets/Images/reg-ico/success.png" alt="e2m">
<h2 class="my-5">The new speaker has been created successfully!</h2>
<div class="ss-cns-foo-btn">
<button type="button" class="btn btn-primary px-4" data-dismiss="modal" >Greate</button>
</div>
</div>

</div>

</div>
</div>
<!---success modal end---->
<!-- Registration Types sidebar start -->
<div class="modal right fade ss-reg-type-sidebar-modal" id="RegistrationtypeModal" tabindex="" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
<div class="modal-dialog" role="document">
<div class="modal-content">
<div class="modal-body">
<div class="reg-type-wrapper">
<div class="reg-type-head">
<h3>Registration Types</h3>
<h3 class="d-none"><a href=""><img src="../assets/Images/reg-ico/back-arrow.svg"/></a> Add Registration Types</h3>
<button type="button" class="close" data-dismiss="modal" aria-label="Close">
<span aria-hidden="true">&times;</span>
</button>
</div>
<div class="create-new-reg-button mt-4">
<button><span><img src="../assets/Images/reg-ico/create-new-reg-type.svg"/></span> Create New</button>
</div>
<div class="reg-type-table mt-5 px-5">
<div class="row">
<div class="col-md-3">Ticket Name <span><img src="../assets/Images/reg-ico/table-filter.svg"/></span></div>
<div class="col-md-1">Price <span><img src="../assets/Images/reg-ico/table-filter.svg"/></span></div>
<div class="col-md-2">Quantity <span><img src="../assets/Images/reg-ico/table-filter.svg"/></span></div>
<div class="col-md-1 d-flex justify-content-between align-items-center">Min Limit <span><img src="../assets/Images/reg-ico/table-filter.svg"/></span></div>
<div class="col-md-1 d-flex justify-content-between align-items-center">Max Limit <span><img src="../assets/Images/reg-ico/table-filter.svg"/></span></div>
<div class="col-md-1">Status</div>
<div class="col-md-1">Visibility </div>
<div class="col-md-2">Action</div>
</div>
<div class="row">
<div class="col-md-3">Attendee</div>
<div class="col-md-1">Free</div>
<div class="col-md-2">98/200</div>
<div class="col-md-1">1</div>
<div class="col-md-1">10</div>
<div class="col-md-1"><div class="status-meet grn">open</div></div>
<div class="col-md-1"><div class="visibility-meet grn">Visible</div></div>
<div class="col-md-2">
<ul class="action-switch">
<li class="mr-4"><a href=""><img src="../assets/Images/reg-ico/edit.svg"/></a></li>
<li><a href=""><img src="../assets/Images/reg-ico/delete.svg"/></a></li>
</ul>
</div>
</div>

<div class="row">
<div class="col-md-3">Commissioner</div>
<div class="col-md-1">$100.00</div>
<div class="col-md-2">10/50</div>
<div class="col-md-1">1</div>
<div class="col-md-1">5</div>
<div class="col-md-1"><div class="status-meet grn">open</div></div>
<div class="col-md-1"><div class="visibility-meet orng">Hidden</div></div>
<div class="col-md-2">
<ul class="action-switch">
<li class="mr-4"><a href=""><img src="../assets/Images/reg-ico/edit.svg"/></a></li>
<li><a href=""><img src="../assets/Images/reg-ico/delete.svg"/></a></li>
</ul>
</div>
</div>

<div class="row">
<div class="col-md-3">President</div>
<div class="col-md-1">$150.00</div>
<div class="col-md-2">20/50</div>
<div class="col-md-1">1</div>
<div class="col-md-1">5</div>
<div class="col-md-1"><div class="status-meet rd">closed</div></div>
<div class="col-md-1"><div class="visibility-meet grn">Visible</div></div>
<div class="col-md-2">
<ul class="action-switch">
<li class="mr-4"><a href=""><img src="../assets/Images/reg-ico/edit.svg"/></a></li>
<li><a href=""><img src="../assets/Images/reg-ico/delete.svg"/></a></li>
</ul>
</div>
</div>

<div class="row">
<div class="col-md-3">Staff</div>
<div class="col-md-1">Free</div>
<div class="col-md-2">24/Unlimited</div>
<div class="col-md-1">1</div>
<div class="col-md-1">10</div>
<div class="col-md-1"><div class="status-meet grn">open</div></div>
<div class="col-md-1"><div class="visibility-meet grn">Visible</div></div>
<div class="col-md-2">
<ul class="action-switch">
<li class="mr-4"><a href=""><img src="../assets/Images/reg-ico/edit.svg"/></a></li>
<li><a href=""><img src="../assets/Images/reg-ico/delete.svg"/></a></li>
</ul>
</div>
</div>
</div>
<div class="add-reg-type-form my-0 d-none">
<div class="switch-field-page-tab">
<input type="radio" id="radio-one" name="switch-one" value="yes" checked/>
<label for="radio-one">Paid</label>
<input type="radio" id="radio-two" name="switch-one" value="no" />
<label for="radio-two">Free</label>
</div>
<div class="add-reg-form-inner">
<label>Type Name<span>*</span></label>
<input type="text" name="" id="" value="" placeholder="Add registration type name"/>

<label>Quantity* <span></span></label>
<input type="text" name="" id="" value="" placeholder="Add Quantity"/>

<label>Short Description(optional)</label>
<textarea cols="5" rows="8" id="" name="" value=""></textarea>

<div class="adv-settings-option mt-3">
<input type="checkbox" value="1" class="switch">
<p>Advanced Settings</p>
</div>
<div class="sales-drop-wrap mt-3">
<div class="row my-0">
<div class="col-md-6">
<div>
<label>Sales Start</label>
<select>
<option>On Specific date &amp; time</option>
<option>On Specific date &amp; time</option>
<option>On Specific date &amp; time</option>
<option>On Specific date &amp; time</option>
<option>On Specific date &amp; time</option>
<option>On Specific date &amp; time</option>
</select>
</div>
</div>
<div class="col-md-6">
<div>
<label>Sales End</label>
<select>
<option>On Specific date &amp; time</option>
<option>On Specific date &amp; time</option>
<option>On Specific date &amp; time</option>
<option>On Specific date &amp; time</option>
<option>On Specific date &amp; time</option>
<option>On Specific date &amp; time</option>
</select>
</div>
</div>
</div>
</div>
<div class="regdate mt-4">
<div class="row my-0">
<div class="col-md-6">
<div class="reg-date position-relative">
<span>Start</span>
<input type="date" name="" id=""/>
</div>
</div>
<div class="col-md-6">
<div class="reg-date position-relative">
<span>End</span>
<input type="date" name="" id=""/>
</div>
</div>
</div>
</div>
<hr/>
<div class="ticket-status-visibility">
<div class="row my-0">
<div class="col-md-6">
<label>Ticket Status</label>
<div class="switch-field-page-tab mb-0">
<input type="radio" id="radio-three" name="switch-two" value="yes" checked/>
<label for="radio-three">Open</label>
<input type="radio" id="radio-four" name="switch-two" value="no" />
<label for="radio-four">Closed</label>
</div>
</div>
<div class="col-md-6">
<label>Ticket Visibility</label>
<div class="switch-field-page-tab mb-0">
<input type="radio" id="radio-five" name="switch-three" value="yes" checked/>
<label for="radio-five">Visible</label>
<input type="radio" id="radio-six" name="switch-three" value="no" />
<label for="radio-six">Hideen</label>
</div>
</div>
</div>
</div>
<hr/>
<div class="order-tickets">
<p>Tickets Per Order</p>
<div class="row">
<div class="col-md-6">
<label>Minimum</label>
<input type="text" name="" id="" value="" placeholder="1"/>
</div>
<div class="col-md-6">
<label>Minimum</label>
<input type="text" name="" id="" value="" placeholder="10"/>
</div>
</div>
</div>

</div>
<div class="submit-form-switch">
<button class="cancel-form">Cancel</button>
<button class="save-form">Save</button>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
<!-- Registration Types sidebar end -->
<!-- Welcome-mail-template start -->
<div class="modal fade welcomemailmodal ss-reg-type-sidebar-modal" id="welcomemailModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered" role="document">
<div class="modal-content">
<div class="modal-body welcome-modal-body">
<button type="button" class="close" data-dismiss="modal" aria-label="Close">
<span aria-hidden="true">&times;</span>
</button>
<div class="welcome-mail-tab">
<p class="mb-0">Choose Template</p>
<div class="switch-field-page-tab mb-0">
<input type="radio" id="radio-seven" name="switch-four" value="yes" checked/>
<label for="radio-seven">Reminder</label>
<input type="radio" id="radio-eight" name="switch-four" value="no" />
<label for="radio-eight">Announcement</label>
</div>
</div>
<div class="email-temp-wrap mt-4">
<h4>Sub: This Event is about to start in 24 hours!</h4>
<div class="email-body">
<iframe src="../assets/Images/reg-ico/email.png" title="email"></iframe>
</div>
</div>
<div class="submit-form-switch">
<button class="cancel-form">Cancel</button>
<button class="save-form">Send</button>
</div>
</div>
</div>
</div>
</div>
<!-- Welcome-mail-template end -->
</div>
<!------------>
</template>
<style>
#success-modal span.btn-pink.sussecc-btn {
margin-top: 15px;
}
.new-btn-design {
display: inline-flex;
justify-content: center;
align-items: center;
flex-direction: row;
margin-left: 15px;
padding: 8px 12px 8px 0;
min-width: auto;
background: #19a883;
border-radius: 5px;
}
.new-btn-design img {
border-right: 1px solid rgba(255, 255, 255, 0.4);
padding: 0 12px;
}
.new-btn-design span {
color: #fff;
font-weight: 600 !important;
font-size: 14px !important;
margin-left: 10px !important;
}
.new-btn-design-disabled {
opacity: 1;
background: #d4d6d7 !important;
}
.three-session #dvBroadcast {
justify-content: flex-start;
}
</style>
<script>
import jQuery from "jquery";
let $ = jQuery;
import { bus } from "@/main";
import APIs from "@/components/APIInit";
// import db from "../components/firebaseInit";
import router from "../router";
var self;
// import Vue from "vue";
// import VueMoment from "vue-moment";
import moment from "moment-timezone";
import firebase from "firebase";
import axios from "axios";

let ticketStatusUpdateTimer;
export default {
data() {
return {
AllowRegistration: true,
ShowEventListLink: true,
ShowHostedByPanel: true,
eventcollectionname: "",
btntextColor: "black",
btnBackColor: "#ef222b",
BannerURL: "",
desktopBanner: "",
mobileBanner: "",
EventsData: [],
clientID: "",
clientName: "",
hostName: "",
clientLogoUrl: "",
eventID: "",
clientProfile: "",
customDomain: "",
ticketStatus: 0,
RegistrationTypes: [],
CheckoutForms: [],
taxPrice: 0,
items: ['foo', 'bar', 'fizz', 'buzz'],
value: ['foo', 'bar', 'fizz', 'buzz'],
Config: {
PayingToLogo: this.clientLogo,
SubmitButtonDisplaylabel: "SUBMIT",
PayingTo: this.clientName,
LandingPageShowHostedByPanel: false,
LandingPageShowEventListLink: false,
},
IsSubmitting: false,
};
},
computed: {
getsubtotal() {
let vm = this;
vm.taxPrice = 0;
return this.RegistrationTypes.reduce((preval, item) => {
let price = item.Price ? item.Price : 0;
if (item.PriceIncludingTax == false)
vm.taxPrice =
Number(vm.taxPrice) +
(
(Number(item.selectedQuantity) * Number(price) * item.Tax) /
100
).toFixed(2);
return preval + Number(item.selectedQuantity) * Number(price);
}, 0);
},
getcurrency() {
let type = this.RegistrationTypes.find((item) => {
return item.Currency || null;
});
return type && type.Currency ? type.Currency.symbol : "$";
},
getMaxMinPrice() {
let minPrice = 0;
let maxPrice = 0;
this.RegistrationTypes.forEach((item, index) => {
if (index > 0) {
minPrice =
item.Price && item.Price < minPrice ? item.Price : minPrice;
maxPrice =
item.Price && item.Price > maxPrice ? item.Price : maxPrice;
} else {
maxPrice = item.Price || 0;
}
});
return { minPrice: Number(minPrice), maxPrice: Number(maxPrice) };
},
getOneFormsMaxMinLimit() {
let MinLimit = 1;
let MaxLimit = 1;
this.CheckoutForms[0].RegistrationTypes.forEach((item, index) => {
if (index > 0) {
MinLimit = item.MinLimit < MinLimit ? item.MinLimit : MinLimit;
MaxLimit = item.MaxLimit > MaxLimit ? item.MaxLimit : MaxLimit;
} else {
MaxLimit = item.MaxLimit;
}
});
return { MinLimit: Number(MinLimit), MaxLimit: Number(MaxLimit) };
},
RegisterButtonText() {
var result = "Register for the event";
if (self.ticketStatus == 1) {
result = "Sale Not Started!";
} else if (self.ticketStatus == 3) {
result = "Sale Ended!";
} else if (self.ticketStatus == 2) {
result = "All Tickets Sold!";
}
return result;
},
CheckoutButtonText() {
var result = "Checkout";
if (self.ticketStatus == 1) {
result = "Sale Not Started!";
} else if (self.ticketStatus == 3) {
result = "Sale Ended!";
} else if (self.ticketStatus == 2) {
result = "All Tickets Sold!";
}
return result;
},
},
filters: {
momentConvert: function (date) {
return moment(new Date(date)).format("MMMM Do YY");
},
},
metaInfo() {
return {
title: this.EventsData ? this.EventsData[0].EventName : "",
meta: [
{
property: "og:title",
content: this.EventsData ? this.EventsData[0].EventName : "",
},
{
property: "og:url",
content: this.customDomain ? this.customDomain : "",
},
{ property: "og:type", content: "website" },
{ property: "og:description", content: "website" },
{ property: "og:site_name", content: "Epiloge" },
{
property: "og:description",
content: this.EventsData ? this.EventsData[0].Description : "",
},
{
property: "og:image",
content: this.EventsData ? this.EventsData[0].EventLogo : "",
},
{
property: "twitter:card",
content: this.EventsData ? this.EventsData[0].EventName : "",
},
{
property: "twitter:title",
content: this.EventsData ? this.EventsData[0].EventName : "",
},
{
property: "twitter:description",
content: this.EventsData ? this.EventsData[0].Description : "",
},
{
property: "twitter:url",
content: this.customDomain ? this.customDomain : "",
},
{
property: "twitter:description",
content: this.EventsData ? this.EventsData[0].Description : "",
},
{
property: "twitter:image",
content: this.EventsData ? this.EventsData[0].EventLogo : "",
},
],
};
},
beforeCreate() {
$("#topmenu").hide();
$("#leftmenu").hide();
},
created() {
self = this;
self.initScreen();
$(window).resize(function () {
self.initScreen();
});
this.$refs.close_modal.click();
},
async mounted() {
// setTimeout(() => {
//   self.showSnackbar("test", "success", "top");
// }, 10000);
self.EventsData = [];
var eventId = this.$route.params.e; // this.$route.query.e;
self.eventID = eventId;
console.log(eventId);
//const storage = firebase.storage();
//const storageRef = storage.ref();
const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
if (location.host.toLowerCase().indexOf("localhost") >= 0) {
//this.result = "uatonair.e2m.live";
// self.hostName = "network.travelgyaan.com";
self.hostName = HOSTURL ? HOSTURL : "onair.e2m.live";
//self.hostName = "onair.e2m.live";
//self.hostName = "neche2020am.e2m.live";
self.hostName = "uatbni.e2m.live";
// this.result = "tci.e2m.live";
//this.result = "uatcapitalgroup.e2m.live";
} else {
self.hostName = HOSTURL ? HOSTURL : location.host;
//self.hostName = location.host;
}
var path;
//console.log(self.hostName);
if (this.hostName.toLowerCase().indexOf("uat") > -1) {
path = "https://resources.e2m.live/uate2monair.appspot.com/";
} else {
path = APIs.googleSoragePath;
}

axios
.get(
path + "OA_UAT%2FClients%2FHosts%2F" + this.hostName + ".json?alt=media"
)
.then(async (res) => {
if (res && res.data) {
bus.$emit("EnableHelpChat", "Event", res.data.ClientId);
}
console.log("res===1", res.data);
self.clientID = res.data.ClientId;
self.clientName = res.data.ClientName;
self.customDomain = res.data.CustomDomain;
axios
.get(
APIs.EventBrandingJsonData +
"?iid=OA_UAT" +
"&cid=" +
self.clientID +
"&eid=" +
self.eventID
)
.then(async (res) => {
console.log("res===2", res.data);
if (res.data.status == 0) {
this.item = res.data.result;
if (res.data.result.ClientInfo) {
self.desktopBanner =
res.data.result.ClientInfo.EventListAssets.banner2048x88;
self.mobileBanner =
res.data.result.ClientInfo.EventListAssets.banner750x103;
// self.BannerURL =
//   res.data.result.ClientInfo.EventListAssets.banner2048x88;
}
// else {
//   self.BannerURL == "";
// }
self.initScreen();
var dateFormat = require("dateformat");

console.log(res.data.result.EventInfo.EventFullName);
var obj = new Object();

obj.eventId = eventId;
obj.EventName = res.data.result.EventInfo.EventFullName;
document.title =
res.data.result.EventInfo.EventFullName +
" - " +
self.clientName;
// obj.EventTimezone = response.data.EventInfo.TimeZone; // moment.tz.guess();
obj.EventTimezoneZ = moment.tz.guess();

console.log(
"response.data.EventInfo:- " + res.data.result.EventInfo
);
obj.EventLogo = res.data.result.EventInfo.EventLogo;
obj.Description = res.data.result.EventInfo.Description;
self.AllowRegistration =
res.data.result.EventInfo.AllowRegistration == undefined
? true
: res.data.result.EventInfo.AllowRegistration;

obj.EventStartDate = dateFormat(
res.data.result.EventInfo.EventStartDate,
"mmm dd, hh:MM TT"
);

obj.EventEndDate = dateFormat(
res.data.result.EventInfo.EventEndDate,
"mmm dd, hh:MM TT"
);

obj.EventStartDateZ = self.GetTimeByZone(
res.data.result.EventInfo.EventStartDate,
res.data.result.EventInfo.TimeZone
);

obj.EventStartDateZ = dateFormat(
obj.EventStartDateZ,
"mmm dd, hh:MM TT"
);
obj.EventEndDateZ = self.GetTimeByZone(
res.data.result.EventInfo.EventEndDate,
res.data.result.EventInfo.TimeZone
);

obj.EventEndDateZ = dateFormat(
obj.EventEndDateZ,
"mmm dd, hh:MM TT"
);
self.EventsData.push(obj);
//------------------------------------------------------
self.clientName = res.data.result.HostInfo.Name;
self.clientLogoUrl = res.data.result.HostInfo.Logo;
self.clientProfile = res.data.result.HostInfo.Profile;
self.getButtonBranding(self.hostName);
self.getStaticFieldSettings(eventId);
self.getCheckoutForm(true);
ticketStatusUpdateTimer = setInterval(function () {
self.getCheckoutForm(false);
}, 5000);
}
});
});
},
// beforeRouteLeave(to, from, next) {
//   //to, from, next
//   //alert("beforeRouteLeave");
//   if (ticketStatusUpdateTimer) {
//     clearInterval(ticketStatusUpdateTimer);
//   }
//   next(true);
// },
beforeDestroy() {
//alert("beforeDestroy");
if (ticketStatusUpdateTimer) {
clearInterval(ticketStatusUpdateTimer);
}
},
methods: {
initScreen() {
if (window.innerWidth > 768) {
self.BannerURL = self.desktopBanner;
} else {
self.BannerURL = self.mobileBanner;
}
},
OpenCheckoutForm() {
if (self.ticketStatus > 0) {
return;
}
$("#register_popup").modal({ backdrop: "static" }, "show");
// ticketStatusUpdateTimer = setInterval(function () {
//   self.getCheckoutForm(false);
// }, 5000);
},
CloseCheckoutForm() {
$("#register_popup").modal("hide");
// if (ticketStatusUpdateTimer) {
//   clearInterval(ticketStatusUpdateTimer);
// }
},
getStaticFieldSettings: function (eventId) {
debugger;
var evntCol = "OA_UAT_" + self.clientID + eventId;
const storage = firebase.storage();
const storageRef = storage.ref();
const objStaticFieldRef = storageRef.child(
evntCol + "/Registration/DefaultRegFormSettings.JSON"
);

objStaticFieldRef.getDownloadURL().then((url) => {
axios.get(url).then((response) => {
console.log(
"static Response Data:- " +
JSON.stringify(response.data.LandingPageShowEventListLink)
);
//------------------------------------------------------------------
self.ShowEventListLink = response.data.LandingPageShowEventListLink;
self.ShowHostedByPanel = response.data.LandingPageShowHostedByPanel;
//-------------------------------------------------------------------------------------
});
});
},
getCheckoutForm: function (firstLoad) {
if (firstLoad) {
bus.$emit("toggleLoader", true);
}
var evntCol = "OA_UAT_" + self.clientID + self.eventID;
const storage = firebase.storage();
const storageRef = storage.ref();
const objStaticFieldRef = storageRef.child(
evntCol + "/Registration/CheckoutForms.JSON"
);
objStaticFieldRef.getDownloadURL().then((url) => {
axios
.get(url)
.then((response) => {
var ticketList = [];
var formsRegTypes = [];
var openTicketCount = 0;
var saleNotStarted = 0;
var soldTicketCount = 0;
var saleEndedCount = 0;
self.CheckoutForms = response.data.CheckoutForms;
self.Config = response.data.Config;
self.CheckoutForms.forEach((cf) => {
if (cf.IsPublished) {
cf.RegistrationTypes.map((rt) => {
formsRegTypes.push(rt.RegistrationTypeId);
});
}
});
response.data.RegistrationTypes.forEach((item) => {
if (
formsRegTypes.includes(item.RegistrationTypeId) &&
item.IsPublished
) {
ticketList.push(item.RegistrationTypeId);
item["selectedQuantity"] = 0;
item["isInActiveTicket"] = false;
item["InActiveMessage"] = "";
if (Number(item.Quantity) <= 0) {
item["isInActiveTicket"] = true;
item["InActiveMessage"] = "All Tickets Sold!";
soldTicketCount++;
} else if (moment().isBefore(moment(item.SaleStartDate))) {
item["isInActiveTicket"] = true;
item["InActiveMessage"] = "Sale Not Started!";
saleNotStarted++;
} else if (moment().isAfter(moment(item.SaleEndDate))) {
item["isInActiveTicket"] = true;
item["InActiveMessage"] = "Sale Ended!";
saleEndedCount++;
} else {
openTicketCount++;
}
var regTypes = self.RegistrationTypes.filter(function (
regType
) {
return regType.RegistrationTypeId == item.RegistrationTypeId;
});
if (regTypes.length == 0) {
self.RegistrationTypes.push(item);
} else {
regTypes[0]["isInActiveTicket"] = item["isInActiveTicket"];
regTypes[0]["InActiveMessage"] = item["InActiveMessage"];
regTypes[0]["Quantity"] = item["Quantity"];
regTypes[0]["MinLimit"] = item["MinLimit"];
regTypes[0]["MaxLimit"] = item["MaxLimit"];
}
}
});
if (firstLoad) {
bus.$emit("toggleLoader", false);
} else {
if (ticketList.length > 0) {
self.RegistrationTypes = self.RegistrationTypes.filter(
function (regType) {
return ticketList.includes(regType.RegistrationTypeId);
}
);
}
}
self.ticketStatus = 0;
if (openTicketCount == 0) {
if (saleNotStarted > 0) {
self.ticketStatus = 1; //Sale Not Started!
} else if (saleEndedCount > 0) {
self.ticketStatus = 3; //Sale Ended!
} else if (soldTicketCount > 0) {
self.ticketStatus = 2; //All Tickets Sold!
}
}
})
.catch(() => {
if (firstLoad) {
bus.$emit("toggleLoader", false);
}
});
});
},
GetTimeByZone: function (strDateTime, timeZone) {
strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
var strtDate = moment.tz(strDateTime, timeZone);
strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
return strtDate._d;
},
getButtonBranding: function (hostName) {
var path;
if (hostName.toLowerCase().indexOf("uat") > -1) {
path = "https://resources.e2m.live/uate2monair.appspot.com/";
} else {
path = APIs.googleSoragePath;
}
axios
.get(
path + "OA_UAT%2FClients%2FHosts%2F" + hostName + ".json?alt=media"
)
.then((res) => {
debugger;
self.btnBackColor = res.data.LoginAssets.loginButtonFillColor;
self.btntextColor = res.data.LoginAssets.loginButtonTextColor;
//$("#btnRegister").css("background-color", self.btnBackColor);
//$("#btnRegister").css("color", self.btntextColor);
$(".acnhDescription").css("border-color", self.btnBackColor);
if (!self.AllowRegistration) {
//alert("1");
var btnRegister = document.getElementById("btnRegister");
btnRegister.setAttribute("disabled", "disabled");
btnRegister.textContent = "Registration Closed";
btnRegister.style.backgroundColor = "grey";
}
});
//------------------------------------------------------------------------------
},
goForEventList: function () {
//router.push({ name: "EventListReg" });
debugger;
router.push({
path: "/register/" + self.clientID,
});
},
goForLogin: function () {
router.push({ name: "Login" });
},
directFormOpen() {
if (self.ticketStatus > 0) {
return;
}
if (
this.RegistrationTypes.length == 1 &&
this.RegistrationTypes[0].MaxLimit == 1
) {
this.RegistrationTypes[0]["selectedQuantity"] = 1;
this.goForRegister();
}
},
goForRegister() {
if (self.ticketStatus > 0) {
return;
}
self.IsSubmitting = true;
let selectedRegistrationTypes = this.RegistrationTypes.filter(function (
item
) {
return item.selectedQuantity > 0;
});
let regTypes = new Object();
let formRegTypes = [];
for (let item of selectedRegistrationTypes) {
//if(item.selectedQuantity > 1){
for (let i = 1; i <= item.selectedQuantity; i++) {
item["FormLabel"] = `${item.RegistrationType} Registrant ${i}`;
formRegTypes.push({ ...item });
}
//}
//else{
//  item['FormLabel'] = `${item.RegistrationType} Registrant`;
//  regTypes.push(item);
//}
regTypes[item.RegistrationTypeId] = item.selectedQuantity;
}

let checkoutPice = this.getsubtotal
? (Number(this.getsubtotal) + Number(this.taxPrice)).toFixed(2)
: Number(this.getsubtotal).toFixed(2);

if (selectedRegistrationTypes.length) {
let headers = {
"content-type": "application/json",
};
let requestData = {
key: {
instanceId: "OA_UAT",
clientId: self.clientID,
eventId: self.eventID,
},
data: regTypes,
};
axios
.post(APIs.InitRegisterAttendee, requestData, {
headers: headers,
})
.then((responseData) => {
debugger;
console.log(responseData);
if (responseData && responseData.data) {
if (responseData.data.status == 0) {
this.$refs.close_modal.click();
router.push({
//path: `/regv3/${self.eventID}`,
name: "Reg3",
params: {
e: self.eventID,
bundleId: responseData.data.bundleId,
expiry: responseData.data.expiry,
regTypes: formRegTypes,
checkoutPice: Number(checkoutPice).toFixed(2),
},
});
} else {
self.showSnackbar(responseData.data.msg, "error", "top");
}
} else {
self.showSnackbar("Something went wrong!", "error", "top");
}
self.IsSubmitting = false;
})
.catch((error) => {
self.IsSubmitting = false;
console.log(error);
});
console.log(checkoutPice);
} else {
self.showSnackbar("Select Atleast One Ticket!", "error", "top");
self.IsSubmitting = false;
}
},
goForRegister1() {
debugger;
let selectedRegistrationTypes = this.RegistrationTypes.filter(function (
item
) {
return item.selectedQuantity > 0;
});
let regTypes = new Object();
var flag = false;
for (let item of selectedRegistrationTypes) {
//if(item.selectedQuantity > 1){
//  for (let i = 1; i <= item.selectedQuantity; i++){
//    item['FormLabel'] = `${item.RegistrationType} Registrant ${i}`;
//    //regTypes.push({...item});
//  }
//}
//else{
//  item['FormLabel'] = `${item.RegistrationType} Registrant`;
//  regTypes.push(item);
//}
if (item.selectedQuantity > 0) {
flag = true;
regTypes[item.id] = item.selectedQuantity;
}
}

let checkoutPice = this.getsubtotal
? (Number(this.getsubtotal) + Number(this.taxPrice)).toFixed(2)
: Number(this.getsubtotal).toFixed(2);

if (selectedRegistrationTypes.length && flag) {
//
let headers = {
"content-type": "application/json",
};
let requestData = {
key: {
instanceId: "OA_UAT",
clientId: self.clientID,
eventId: self.eventID,
},
data: regTypes,
};
axios
.post(APIs.InitRegisterAttendee, requestData, {
headers: headers,
})
.then((responseData) => {
debugger;
console.log(responseData);
})
.catch((error) => {
debugger;
console.log(error);
});

//this.$refs.close_modal.click();
//router.push({
//  //path: `/regv3/${self.eventID}`,
//  name: "Reg3",
//  params: {
//    e: self.eventID,
//    regTypes: regTypes,
//    checkoutPice: Number(checkoutPice).toFixed(2),
//  },
//});
console.log(checkoutPice);
} else alert("Select Atleast One Ticket!");
},
},
};
</script>